import { EEventType } from './../../../../enums/EEventType';
import OY from "../../../../types/OY";
import styles from './index.module.less';
import template from './index.art';
import { IOYBalanceWeightProps, IOYBalanceWeightState } from "./const";
import { jeact } from '../../../../decorators/jeact';

@jeact({ autoRender: true })
export default class OYBalanceWeight extends OY<IOYBalanceWeightProps, IOYBalanceWeightState> {
  static displayName = 'OYBalanceWeight';

  static defaultProps: Partial<IOYBalanceWeightProps> = {
    name: ''
  };

  state: IOYBalanceWeightState = {
    checkedValue: '',
    inputData: ['', '']
  }

  $node = {}

  getDerivedStateFromProps(nextProps: IOYBalanceWeightProps, state: IOYBalanceWeightState) {
    const { info, value } = nextProps;
    let { inputData, checkedValue } = state;
    if (value) {
      const data = info.find(va => va.value === value);
      if (!data) {
        inputData = value.split('/');
      } else {
        checkedValue = data.value;
      }
    }
    return { ...state, inputData, checkedValue }
  }

  render() {
    return template({ props: this.props, state: this.state, styles })
  }

  renderRadio() {
    const { info } = this.props;
    this.$el.find('oy-radio').OYRadio({
      value: this.state.checkedValue,
      info,
      onChange: (changeValue: string) => {
        this.eventEmitter.emit(EEventType.onChange, changeValue)
        this.eventEmitter.emit(EEventType.onSearch);
      }
    })
  }

  renderRangeInput() {
    this.$el.find('oy-input-range').OYInputRange({
      value: this.state.inputData,
      valtype: 'positiveFloat',
      decimal: 3,
      onChange: (value: string[]) => {
        this.state.inputData = value
      }
    })
  }

  renderButton() {
    this.$el.find('oy-button').OYButton({
      onClick: () => {
        const { inputData } = this.state;
        if (!inputData[0] && !inputData[1]) {
          return;
        }
        this.eventEmitter.emit(EEventType.onChange, `${inputData[0]}/${inputData[1]}`)
        this.eventEmitter.emit(EEventType.onSearch);
      }
    })
  }

  setNode() {

  }
}



// WEBPACK FOOTER //
// ./src/components/OYFilter/components/OYBalanceWeight/index.ts